import { render, staticRenderFns } from "./LocalInsights.vue?vue&type=template&id=6b1eb556&"
import script from "./LocalInsights.vue?vue&type=script&lang=js&"
export * from "./LocalInsights.vue?vue&type=script&lang=js&"
import style0 from "./LocalInsights.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports